<button type="button" #openMercadoPago class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" [hidden]="true"></button>
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <iframe width="100%" height="650px" [src]="urlMercadoPago | sanitizeUrl"></iframe>
      </div>
      <div class="modal-footer border-0" >
        <button class="class-btn-confirm" mat-raised-button color="primary" data-bs-dismiss="modal">Cancelar</button>
      </div>
    </div>
    
  </div>
</div> 